import { produce } from 'immer';

import { LockExtensionsRequestType } from 'constants/loanApplication';

import { RESET_STATE } from 'store/global/actions';

import { LOCK_INFO_ACTION_TYPE } from '../actions';

// the most of properties are possibly not used anymore, but were left for compability
const initialState = {
  automatedAdjustments: [],
  customAdjustments: {},
  lockExtensions: {},
  lockExtensionSettings: [],
  maxExtensionPeriodDays: 0,
  floatDowns: [],
  metadata: {},
  llpaCaps: {},
  relockConfiguration: {},
  lockDeskConfiguration: {},
  floatDownConfiguration: {},
};

const lockInfoAdjustmentsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOCK_INFO_ACTION_TYPE.GET_LOCK_EXTENSION_SETTINGS: {
        draft.lockExtensionSettings = payload?.lockExtensions || initialState.lockExtensionSettings;

        if (payload.type === LockExtensionsRequestType.EXTERNAL) {
          draft.relockConfiguration =
            payload.relockConfiguration ?? initialState.relockConfiguration;
          draft.lockDeskConfiguration =
            payload.lockDeskConfiguration ?? initialState.lockDeskConfiguration;
          draft.floatDownConfiguration =
            payload.floatDownConfiguration ?? initialState.floatDownConfiguration;
        }

        draft.maxExtensionPeriodDays =
          payload?.maxExtensionPeriodDays || initialState.maxExtensionPeriodDays;
        break;
      }

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default lockInfoAdjustmentsReducer;
